import { dictionary } from '../constants/dictionary.constant';
import * as moment from 'moment';

export const purchaseInfoAdapter = (purchase) => {
	return {
		email: purchase?.info?.email,
		first_name: purchase?.info.first_name,
		last_name: purchase?.info?.last_name,
		phone: purchase?.info?.phone,
		rut: purchase?.info?.rut,
		type_retirement: dictionary[purchase?.info.type_retirement],
		pharmacy: purchase?.info?.pharmacy?.[0]?.pharmacy?.toUpperCase(),
		schedule_selected: purchase?.info?.pharmacy[0].schedule_selected,
		commune: purchase?.info?.pharmacy?.[0]?.commune,
		direction: purchase?.info?.pharmacy?.[0]?.direction,
		address: purchase?.info?.commune + ',' + purchase?.info?.street + ' ' + purchase?.info?.street_number + ',' + purchase?.info?.type_house,
		createdAt: moment.unix(purchase?.createdAt).format('DD/MM/YYYY HH:mm A'),
		trx_id: purchase?.trx_id,
		sub_total: purchase?.sub_total,
		total_delivery: purchase?.total_delivery,
		total:purchase?.total,
		
	};
};
